<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BasicLayout',
})
</script>
<template>
    <a-layout :class="['layout', device]">
        <!-- SideMenu -->
        <a-drawer v-if="isMobile" placement="left" :class="`drawer-sider ${navTheme}`" :closable="false"
            :open="collapsed" @close="drawerClose" width="256px">
            <side-menu mode="inline" :menus="$store.state.permission.addRouters" :theme="navTheme" :collapsed="false"
                :collapsible="true"></side-menu>
        </a-drawer>

        <side-menu v-else-if="isSideMenu()" mode="inline" :menus="$store.state.permission.addRouters" :theme="navTheme"
            :collapsed="collapsed" :collapsible="true"></side-menu>

        <a-layout :class="[layoutMode, `content-width-${contentWidth}`]"
            :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }">
            <global-header :mode="layoutMode" :menus="$store.state.permission.addRouters" :theme="navTheme"
                :collapsed="collapsed" :device="device" @toggle="toggle" @refresh="onRefresh" />
            <a-layout-content :style="{
                height: '100%',
                margin: '24px 24px 0',
                paddingTop: fixedHeader ? '64px' : '0'
            }">
                <multi-tab v-if="multiTab"></multi-tab>
                <transition name="page-transition">
                    <section>
                        <route-view v-if="showRouter" />
                    </section>
                </transition>
            </a-layout-content>
            <a-layout-footer>
                <global-footer />
            </a-layout-footer>
            <setting-drawer></setting-drawer>
            <InformDrawer></InformDrawer>
            <UsbPhone v-if="$store.state.usbphone.modalVisible"></UsbPhone>
        </a-layout>

        <!-- 新增：全局悬浮挂断按钮，只加这一块，其余布局不动 -->
        <div class="float-hang-wrap">
            <a-button shape="circle" v-if="$store.state.usbphone.p_status !== 0" @click="handleForceHang">
                <template #icon>
                    <PhoneTwoTone />
                </template>
            </a-button>
        </div>
    </a-layout>
</template>

<script lang="ts" setup name="BasicLayout">
import { ref, computed, watch, onMounted, nextTick } from 'vue'
import { triggerWindowResizeEvent, isMobile, isDesktop } from '@/utils/device'
import RouteView from './RouteView.vue'
import MultiTab from '@/components/MultiTab/index.vue'
import SideMenu from '@/components/Menu/SideMenu.vue'
import GlobalHeader from '@/components/GlobalHeader/index.vue'
import GlobalFooter from '@/components/GlobalFooter/index.vue'
import SettingDrawer from '@/components/SettingDrawer/index.vue'
import InformDrawer from '@/components/InformDrawer/index.vue'
import UsbPhone from '@/components/UsbPhone/index.vue'
// 新增图标与提示
import { PhoneTwoTone } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

import { convertRoutes } from '@/router/generateAsyncRoutes'
import { filteRouterPermission } from '@/router/permission'
import cloneDeep from 'lodash.clonedeep'
import useSiteSettings from '@/store/useSiteSettings'
import ls from '@/utils/Storage'
import { systemConfig } from '@/store/reactiveState'
import { useRouter } from 'vue-router'
import emitter from '@/utils/eventBus'
import { useStore } from 'vuex'
const $store = useStore()

const router = useRouter()
const collapsed = ref(false)
const menus = ref([])
const { fixSidebar, sidebarOpened, multiTab, device, layoutMode, contentWidth, fixedHeader, navTheme, isSideMenu } = useSiteSettings()

const contentPaddingLeft = computed(() => {
    if (!fixSidebar.value || isMobile.value) {
        return '0'
    }
    if (sidebarOpened.value) {
        return '256px'
    }
    return '80px'
})

let mainMenu = router.getRoutes()
let user = ls.get('USER_INFO')
const routes = convertRoutes(mainMenu.find((item) => item.path === '/'))

menus.value = (routes && routes.children) || []
collapsed.value = !sidebarOpened.value

onMounted(() => {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
        nextTick(() => {
            collapsed.value = !collapsed.value
            setTimeout(() => {
                collapsed.value = !collapsed.value
            }, 16)
        })
    }
})

const toggle = () => {
    collapsed.value = !collapsed.value
    systemConfig.commit('SET_SIDEBAR_TYPE', !collapsed.value)
    triggerWindowResizeEvent()
}
const drawerClose = () => {
    collapsed.value = false
}

const showRouter = ref(true)
const onRefresh = () => {
    emitter.all.clear()
    showRouter.value = false
    nextTick(() => (showRouter.value = true))
}

// 新增挂断方法
const handleForceHang = () => {
    const status = $store.state.usbphone.p_status
    if (status === 0) {
        message.info('暂无通话，无需挂断')
        return
    }
    $store.dispatch('usbphone/PhoneCallEnd')
    message.success('已执行挂断，正在保存录音')
}
</script>

<style lang="less">
/* 原有页面过渡样式保留 */
.page-transition-enter {
    opacity: 0;
}

.page-transition-leave-active {
    opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

/* 新增悬浮按钮样式 */
.float-hang-wrap {
    position: fixed;
    top: 50px;
    left: 50%;
    z-index: 99999;
}

.float-hang-wrap .ant-btn {
    width: 64px;
    height: 64px;
    font-size: 20px;
}
</style>
